import { DIALOG_TYPE, LayoutConfig } from '@spartacus/storefront'
import { CreditClaimAttachmentsModalComponent } from './credit-claim-attachments-modal.component'

export const customOpenCreditClaimAttachmentsLayoutConfig: LayoutConfig = {
  launch: {
    CUSTOM_OPEN_CREDIT_CLAIM_ATTACHMENTS: {
      inlineRoot: true,
      component: CreditClaimAttachmentsModalComponent,
      dialogType: DIALOG_TYPE.DIALOG
    }
  }
}
